import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import wishlistIcon from '../../assets/wishlistIcon.svg';
import EmptyProfile from '../../assets/EmptyProfile.svg';
import WishlistPopup from '../Popups/wishlistPopup';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  useMediaQuery,
} from '@chakra-ui/react';
import { useUserContext } from '../../context/user_context';
import cartIcon from "../../assets/cartIcon.svg"
import CartPopup from '../Popups/cartPopup';
import { useCartContext } from '../../context/cart_context';
import {
  FaShoppingCart,
  
} from 'react-icons/fa';
const CartButtons = ({ closeSidebar }) => {
  const { currentUser} = useUserContext();
  const [showWishlist, setShowWishlist] = useState(false);
  const [showCartList, setShowCartList]=useState(false)
  const [isMobile] = useMediaQuery('(max-width: 1024px)');
  const isMounted = useRef(true);
  const {total_items}=useCartContext()
  
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const safeSetShowWishlist = (value) => {
    if (isMounted.current) {
      setShowWishlist(value);
    }
  };
  const openWishlist = () => safeSetShowWishlist(true);
  const closeWishlist = () => safeSetShowWishlist(false);

  const closeCartlist=()=>{
    setShowCartList(false)
  }
  return (
    <div className='relative flex items-center gap-4 ml-5'>
      {currentUser && (
        <div className='relative' onClick={() => setShowWishlist(true)}>
          <img
            src={wishlistIcon}
            alt='wishlist'
            className='w-6 h-6 cursor-pointer'
          />

          {!isMobile && showWishlist && (
            <div className='absolute top-8 right-0 z-50'>
              <WishlistPopup onClose={closeWishlist} />
            </div>
          )}

          {isMobile && (
            <Modal
              isOpen={showWishlist}
              onClose={closeWishlist}
              size='md'
              motionPreset='slideInBottom'
              isCentered
            >
              <ModalOverlay />
              <ModalContent
                bg='white'
                borderRadius='lg'
                p='4'
                maxH='80vh'
                overflowY='auto'
              >
                <WishlistPopup onClose={closeWishlist} />
              </ModalContent>
            </Modal>
          )}
        </div>
      )}
      {currentUser && (
        <Link to='/cart'>
          <div
            className='relative'
            onMouseEnter={() => !isMobile && setShowCartList(true)}
            onMouseLeave={() => setShowCartList(false)}
            onClick={() => {
              setShowCartList(false);
              closeSidebar()
            }}
          >
            <span className='flex justify-between mb-4' >
              <span className='bg-[#D3A143] flex justify-center items-center rounded-full ml-3 h-[20px] w-[20px] text-white absolute'>
                {total_items}
              </span>
              <img
                src={cartIcon}
                alt='cart'
                className='relative h-[25px] w-[25px] top-3 mb-3'
              />
            </span>

            {!isMobile && showCartList && (
              <div className='absolute top-8 right-0 z-50'>
                <CartPopup
                  onClose={closeCartlist}
                  closeSidebar={closeSidebar}
                />
              </div>
            )}

            {isMobile && (
              <Modal
                isOpen={showCartList}
                onClose={closeCartlist}
                size='md'
                motionPreset='slideInBottom'
                isCentered
              >
                <ModalOverlay />
                <ModalContent
                  bg='white'
                  borderRadius='lg'
                  p='4'
                  maxH='80vh'
                  overflowY='auto'
                >
                  <CartPopup
                    onClose={closeCartlist}
                    closeSidebar={closeSidebar}
                  />
                </ModalContent>
              </Modal>
            )}
          </div>
        </Link>
      )}
      <Link to='/profile' onClick={closeSidebar}>
        <img
          src={currentUser?.profileImage || EmptyProfile}
          alt='profile'
          className='w-6 h-6 cursor-pointer rounded-full'
        />
      </Link>
    </div>
  );
};

export default CartButtons;
